<template>
  <div class="homework">
    <div class="filter">
      <button 
        type="button" 
        class="header-menu__btn" 
        @click="$emit('add-lesson-block')"
        uk-tooltip="Создать задание"
      >
        <i class="fas fa-plus-circle"></i>
      </button>

      <p class="form__field">
        <v-select 
          label="name" 
          :options="classItem.students" 
          v-model="student_id" 
          placeholder="Фильтр по ученику"
          :reduce="option => option.id"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>
      </p>      
    </div>

    <ul class="homework__list">
      <HomeworkItem 
        :class_students="classItem.students"
        :classLessons="classLessons" 
        v-for="(lesson, index) in filteredHomework" 
        :key="lesson.id" 
        :item="lesson"
        :index="index"      
        @remove-lesson-block="removeLessonBlock"
      />
    </ul>

    <p class="missing-message" v-show="!filteredHomework.length">Заданий нет</p>

  </div>
</template>

<script>
import { deleteItem } from '../../../../other/methods/list_actions'
import { mapState } from 'vuex'

import vSelect from 'vue-select'
import HomeworkItem from "./HomeworkItem";
export default {
  inject: ['http'],
  props: ['classItem', 'classLessons', 'is_dynamical'],
  components: { vSelect, HomeworkItem },
  data() {
    return {
      student_id: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    filteredHomework() {
      let lessons = []
      if (this.is_dynamical) {
        lessons = _.cloneDeep(this.classLessons).filter(item => item.is_dynamical)
      } else {
        lessons = _.cloneDeep(this.classLessons).filter(item => !item.is_dynamical)
      }

      if (this.student_id) {
        lessons.forEach(lesson => {
          lesson.trainers = lesson.trainers.filter(t => t.students.includes(this.student_id))
        })
      }
      return lessons.filter(item => item.trainers.length || item.is_new)
    }
  },
  methods: {
    deleteItem,
    removeLessonBlock(data) {
      if (!data.is_new) {
        swal({
          title: 'Внимание!',
          text: `Действительно желаете удалить задание?`,
          icon: "warning",
          buttons: ['Отмена', 'Да'],
          dangerMode: true,
        })
        .then((choise) => {
          if (choise) {
            this.http.post('onDeleteClassLesson', { id: data.id }).then(() => {
              this.deleteItem(data.id, this.classLessons)
              swal('Успешно!', 'Задание удалено', 'success')
            }) 
            .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
          } 
        }) 
      } else {
        this.deleteItem(data.id, this.classLessons)
      }
    }    
  }
}
</script>

<style lang="scss" scoped>
.filter {
  width: 300px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.form__field {
  margin: 0;
  width: 240px;
}
.homework {
  width: 100%;
}
.homework__list {
  width: 100%;
  padding: 0;
  margin: 0;
  margin-top: 30px;
  list-style: none;
}

.header-menu__btn {
  font-size: 22px;
  margin-right: 10px;
}
</style>